import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import {
  Checkbox,
  InfoIcon,
  Input,
  InputPhone,
  Label,
  Tooltip,
} from '@mercai/clever'

import { FormPaymentManagerProps } from './form-payment-manager.type'
import styles from './form-payment-manager.module.css'

const FormPaymentManager = ({
  profile,
  data,
  onChange,
}: FormPaymentManagerProps) => {
  const { t } = useTranslation('screenProfileShow')

  const handleInputChange =
    (fieldName: string) => (fieldValue: string | boolean) => {
      onChange((prev) => ({ ...prev, [fieldName]: fieldValue }))
    }

  useEffect(() => {
    if (profile) {
      onChange({
        name: profile?.paymentsRepresentative?.name || '',
        email: profile?.paymentsRepresentative?.email || '',
        phone: profile?.paymentsRepresentative?.phone || '',
        addToAccount: profile?.paymentsRepresentative?.addToAccount || false,
      })
    }
  }, [profile])

  return (
    <fieldset className={styles.core}>
      <div className={styles['input-item']}>
        <Label className={styles.label} htmlFor="name">
          {t('formLegalRepresentativeNameField')}
        </Label>
        <Input
          value={data.name}
          onChange={handleInputChange('name')}
          id="name"
          placeholder="Juan Pérez Rodríguez"
        />
      </div>

      <div className={styles['input-item']}>
        <Label className={styles.label} htmlFor="email">
          {t('formLegalRepresentativeCorreoField')}
        </Label>
        <Input
          value={data.email}
          onChange={handleInputChange('email')}
          id="email"
          placeholder="juan@gmail.com"
        />
      </div>

      <div className={styles['input-item']}>
        <Label className={styles.label}>
          {t('formLegalRepresentativeCorreoField')}
        </Label>
        <InputPhone
          value={data.phone}
          onChange={handleInputChange('phone')}
          defaultCountry={'mx'}
        />
      </div>

      <Checkbox
        value={data.addToAccount}
        className={styles.checkbox}
        onChange={handleInputChange('addToAccount')}
      >
        <div className={styles['checkbox-text']}>
          {t('formLegalRepresentativeAgregarCuentaField')}{' '}
          <Tooltip
            text={t('formLegalRepresentativeAgregarCuentaTooltip')}
            orientation="right"
            className={styles['question-tooltip']}
            widthText="20rem"
            textClassname={styles['tooltip-text']}
          >
            <InfoIcon />
          </Tooltip>
        </div>
      </Checkbox>
    </fieldset>
  )
}

export default FormPaymentManager
